import fs from "fs";
import path from "path";

// Usage:
// metis auth set --provider openai --key sk-XXXX
// metis auth show
export async function runAuth(args: string[]) {
  const cwd = process.cwd();
  const metisDir = path.join(cwd, ".metis");
  const secretsFile = path.join(metisDir, "secrets.json");

  if (!fs.existsSync(metisDir)) fs.mkdirSync(metisDir);
  if (!fs.existsSync(secretsFile)) fs.writeFileSync(secretsFile, JSON.stringify({}, null, 2));

  const sub = args[0];
  if (sub === "show") {
    const data = JSON.parse(fs.readFileSync(secretsFile, "utf8") || "{}");
    const redacted = Object.fromEntries(
      Object.entries<string>(data).map(([k, v]) => [k, v ? redact(v) : v])
    );
    console.log(JSON.stringify(redacted, null, 2));
    return;
  }

  if (sub === "set") {
    const { provider, key } = parseArgs(args.slice(1));
    if (!provider || !key) {
      console.error("Usage: metis auth set --provider <name> --key <secret>");
      process.exitCode = 1;
      return;
    }
    const data = JSON.parse(fs.readFileSync(secretsFile, "utf8") || "{}");
    data[provider] = key;
    fs.writeFileSync(secretsFile, JSON.stringify(data, null, 2) + "\n");
    console.log(`Saved key for provider '${provider}' to .metis/secrets.json`);
    console.log("Never commit this file. It is gitignored by default.");
    return;
  }

  printHelp();
}

function parseArgs(tokens: string[]) {
  let provider: string | undefined;
  let key: string | undefined;
  for (let i = 0; i < tokens.length; i++) {
    const t = tokens[i];
    if (t === "--provider" || t === "-p") provider = tokens[++i];
    else if (t === "--key" || t === "-k") key = tokens[++i];
  }
  return { provider, key };
}

function printHelp() {
  console.log(`
Usage:
  metiscode auth show
  metiscode auth set --provider <name> --key <secret>
`);
}

function redact(str: string) {
  if (str.length <= 6) return "***";
  return str.slice(0, 3) + "***" + str.slice(-3);
}
